'use client';

import { Button } from '@/components/ui/button';
import { useTranslations } from 'next-intl';
import { Plus } from 'lucide-react';
import { Link } from '@/i18n/routing';

import { StorageLocationsStatCards } from './storage-locations-stat-cards';
import { StorageLocationsListing } from './storage-locations-listing';

export function StorageLocationsPageContent() {
  const t = useTranslations('storageLocations');

  return (
    <div className='space-y-6'>
      <div className='flex items-center justify-between'>
        <div>
          <h1 className='text-3xl font-bold'>{t('pageTitle')}</h1>
          <p className='text-muted-foreground mt-1'>{t('pageDescription')}</p>
        </div>
        <Button asChild>
          <Link href='/dashboard/storage-locations/new'>
            <Plus className='me-2 h-4 w-4' />
            {t('addNew')}
          </Link>
        </Button>
      </div>

      <StorageLocationsStatCards />

      <StorageLocationsListing />
    </div>
  );
}
